import { useFetchConfig } from '@/components/ConfigsProvider';
import { ResourceVersionTypeEnum } from '@/types/schema';

export const DEFAULT_PUBLISH_CONFIG = {
  versionType: ResourceVersionTypeEnum.Major,
  recalibrateConfig: {
    recalibrateInProgressPerformances: true,
    recalibrateCompletedPerformances: true,
  },
  note: '',
};

const useDefaultPublishConfig = (allowMinorVersionPublish?: boolean) => {
  const { publishContentConfigProperties } = useFetchConfig(['publishContentConfigProperties']);
  if (!publishContentConfigProperties || !allowMinorVersionPublish) {
    return DEFAULT_PUBLISH_CONFIG;
  }

  // in progress performances should always be recalibrated. hence, not taken from config
  return {
    versionType: publishContentConfigProperties.defaultVersion,
    recalibrateConfig: {
      recalibrateInProgressPerformances: true,
      recalibrateCompletedPerformances:
        publishContentConfigProperties.recalibrateConfig?.recalibrateCompletedPerformances,
    },
    note: '',
  };
};

export default useDefaultPublishConfig;
